import { render, staticRenderFns } from "./DeletedChanges.vue?vue&type=template&id=4c7f2a29&"
import script from "./DeletedChanges.vue?vue&type=script&lang=js&"
export * from "./DeletedChanges.vue?vue&type=script&lang=js&"
import style0 from "./DeletedChanges.vue?vue&type=style&index=0&id=4c7f2a29&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports